import React from 'react';
import { Check, AlertTriangle, Loader2 } from 'lucide-react';

// Props:
//   detection: { quality: 'good'|'warn'|'fail', reason: string|null } | null  — null = not yet run
//   poseKey: string — one of the 7 pose keys; 'relaxed' (favorite pose) shows neutral state
//   className: optional — positioning classes from the parent
export default function PoseAlignFeedback({ detection, poseKey, className = '' }) {
  const isFavorite = poseKey === 'relaxed';

  let tone, Icon, label, hint;
  if (isFavorite) {
    tone = 'bg-zinc-700/70 text-white';
    Icon = Check;
    label = 'Favorite pose';
    hint = null;
  } else if (!detection) {
    tone = 'bg-zinc-700/70 text-white';
    Icon = Loader2;
    label = 'Detecting…';
    hint = null;
  } else if (detection.quality === 'good') {
    tone = 'bg-emerald-600/85 text-white';
    Icon = Check;
    label = 'Aligned';
    hint = null;
  } else if (detection.quality === 'warn') {
    tone = 'bg-amber-500/90 text-white';
    Icon = AlertTriangle;
    label = 'Adjust';
    hint = detection.reason;
  } else {
    tone = 'bg-red-600/90 text-white';
    Icon = AlertTriangle;
    label = 'Off';
    hint = detection.reason;
  }

  return (
    <div className={`pointer-events-none ${className}`}>
      {/* group wrapper so the hint appears only on hover/focus of the pill */}
      <div className="relative group pointer-events-auto inline-block">
        <div
          className={`flex items-center gap-1.5 px-2 py-1 rounded-full text-[11px] font-semibold uppercase tracking-wide ${tone} cursor-help`}
          tabIndex={hint ? 0 : -1}
        >
          <Icon className={`h-3 w-3 ${!detection && !isFavorite ? 'animate-spin' : ''}`} />
          <span>{label}</span>
        </div>
        {hint && (
          <div className="absolute top-full left-0 mt-1 px-2 py-1 rounded bg-black/85 text-white text-[10px] max-w-[180px] leading-tight opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity pointer-events-none z-10 whitespace-normal shadow-lg">
            {hint}
          </div>
        )}
      </div>
    </div>
  );
}
